import React from "react";
import { BundledQuoteProduct } from "@/Contracts/ProposalBuilder/Block";
import {
	ProductBillingType,
	productBillingTypeOptions,
	BundleProduct
} from "@/Contracts/Products";
import { Tag } from "antd";

import "./BundledProductRowFormNameLabel.less";

export const BundledProductRowFormNameLabel: React.FC<
	BundledProductRowFormNameLabelProps
> = props => {
	const { selected_billing_period, name, is_optional } = props.product;
	return (
		<div className="bundled-product-row-name-container">
			{selected_billing_period &&
				selected_billing_period !== ProductBillingType.OneTime && (
					<Tag color="blue">
						{productBillingTypeOptions[selected_billing_period]}{" "}
						Recurring
					</Tag>
				)}
			{is_optional && (
				<Tag color="#eff1f7" className="optional-tag">
					Optional
				</Tag>
			)}
			<div className="product-name">{name}</div>
			{props.children}
		</div>
	);
};
interface BundledProductRowFormNameLabelProps {
	product: BundledQuoteProduct | BundleProduct;
}
